// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AYhg2cTmb6oSHZ {
  margin-bottom: var(--ds-space-300, 24px);
}
.gVZ4cU4yvm8ekS {
  font-size: 14px;
  text-transform: uppercase;
}
.XAf1BOz2tur1AD {
  padding-left: var(--ds-space-0, 0);
}
.d6AIBo1EEDDyak {
  margin: var(--ds-space-400, 32px) var(--ds-space-0, 0) var(--ds-space-200, 16px) var(--ds-space-0, 0);
}
.WAyHTwYBrgX2ok {
  margin-bottom: var(--ds-space-200, 16px);
}
.AsYX_nfmjkRJoZ {
  margin-bottom: var(--ds-space-200, 16px);
}
.f1mYWku9n4XRN5:focus {
  outline: none;
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
`, ""]);
// Exports
export var header = `AYhg2cTmb6oSHZ`;
export var step = `gVZ4cU4yvm8ekS`;
export var backButton = `XAf1BOz2tur1AD`;
export var summarySection = `d6AIBo1EEDDyak`;
export var tosSection = `WAyHTwYBrgX2ok`;
export var submitError = `AsYX_nfmjkRJoZ`;
export var submit = `f1mYWku9n4XRN5`;
export default ___CSS_LOADER_EXPORT___;
